import SeamlyBaseError from './seamly-base-error'

export default class SeamlyGeneralError extends SeamlyBaseError {
  constructor(originalError?: any, ...params) {
    super(originalError, ...params)

    this.name = 'SeamlyGeneralError'
    this.langKey = 'errors.general'
    this.action = 'reset'
  }
}
